import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../../images/edit.svg";
import Delete from "../../../images/delete.svg";
import Logo from "../../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack, Switch } from "@mui/material";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Email } from "@mui/icons-material";

export function PollAdmin({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // console.log(window.location);
  // console.log(match.url);
  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.getPollsAdmin(payload);
      console.log(postData);
      if (postData?.success) {
        setData(postData.polls);
        setnoOfPost(postData.count);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const togglePoll = async (e, pollId) => {
    try {
      setLoader(true);
      const isConfirmed = window.confirm(
        `Are you sure you want to ${
          e.target.checked ? "active" : "in-active"
        } this poll?`
      );
      let payload = {
        pollId,
        active: e.target.checked,
      };
      if (isConfirmed) {
        const userData = await api.pollToggle(payload);
        console.log(userData);
        if (userData?.success) {
          console.log("updated");
          getPosts();
        }
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page, resetPage]);

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.searchBlacklistEmails(payload);
      // console.log(res);
      if (res?.success) {
        setData(res?.emails);
        setLimit(res?.emails?.length || 10);
        setnoOfPost(res?.emails?.length || 0);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12 d-flex justify-content-end">
                <button className="themeBtn" onClick={handleShow}>
                  Create Poll
                </button>
              </div>
              <div className="col-12 d-flex justify-content-between pr-0 flex-wrap mt-2">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Polls ({noOfPost})
                </h4>
                {/* <div className="searchMadmin">
                  <div className="inputM">
                    <div className="iM">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        onChange={(e) => setSearchMail(e.target.value)}
                        type="text"
                        placeholder="Search by email..."
                      />
                    </div>
                    <i
                      className="fa-solid fa-magnifying-glass sIcon"
                      onClick={handleSearch}
                    ></i>
                  </div>
                  <button className="reset" onClick={() => handleReset()}>
                    <i className="fa-solid fa-arrow-rotate-right"></i>
                    Reset
                  </button>
                </div> */}
              </div>
            </div>
            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              togglePoll={togglePoll}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {/* /.container-fluid */}
      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddPoll getPosts={getPosts} setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>
      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noOfPost, limit, togglePoll }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Title
                  </th>
                  <th scope="col" className="">
                    Options
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Total Votes</div>
                  </th>
                  <th scope="col" className="">
                    Active
                  </th>
                  <th scope="col" className="">
                    Created By
                  </th>
                  <th scope="col" className="">
                    Created At
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.title || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark  db">
                        {item?.options.map((val, key1) => (
                          <div>
                            ({val?.votes}) {val?.text}
                          </div>
                        ))}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark  db">
                        {item?.totalVotes || 0}
                      </div>
                    </td>
                    <td>
                      <div className="mr-5 w-40">
                        {/* <a
                          className="cursor-pointer"
                          onClick={() => togglePoll(item?._id, item?.active)}
                        >
                          <img src={Delete} alt="Delete" />
                        </a> */}
                        <Switch
                          checked={item?.active}
                          onChange={(e) => togglePoll(e, item?._id)}
                          slotProps={{ input: { "aria-label": "controlled" } }}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark  db">
                        {item?.createdBy?.email || "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.max(1, Math.ceil(noOfPost / limit))}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export function AddPoll({ getPosts, setShow, onCreated }) {
  const [title, setTitle] = useState("");
  const [options, setOptions] = useState(["", ""]); // start with 2 options
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleOptionChange = (idx, value) => {
    const newOpts = [...options];
    newOpts[idx] = value;
    setOptions(newOpts);
  };

  const addOption = () => setOptions((o) => [...o, ""]);
  const removeOption = (idx) => {
    if (options.length <= 2) return; // keep minimum 2 options
    setOptions((o) => o.filter((_, i) => i !== idx));
  };

  const validate = () => {
    if (!title.trim()) return "Title is required";
    const trimmedOpts = options.map((o) => o.trim()).filter(Boolean);
    if (trimmedOpts.length < 2) return "At least two options are required";
    const lower = trimmedOpts.map((s) => s.toLowerCase());
    if (new Set(lower).size !== lower.length) return "Options must be unique";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const vErr = validate();
    if (vErr) {
      alert(vErr);
    }

    setLoading(true);

    try {
      const payload = {
        title: title.trim(),
        options: options.map((o) => o.trim()),
        active,
      };

      const res = await api.createPoll(payload);

      if (res?.success) {
        setTitle("");
        setOptions(["", ""]);
        setActive(true);
        getPosts();
        setShow(false);
        alert("Poll created successfully!");
      } else {
        alert(res.data?.message || "Failed to create poll");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to create poll");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <h3 className="text-lg font-semibold mb-4">Create Poll</h3>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="form-group mb-2">
          <label className="">Poll Title</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="What do you think about our latest product?"
            className="form-control"
          />
        </div>

        <div className="form-group mb-2">
          <label className="">Options</label>

          <div className="space-y-2">
            {options.map((opt, idx) => (
              <div key={idx} className="d-flex items-center gap-2 mb-1">
                <input
                  value={opt}
                  onChange={(e) => handleOptionChange(idx, e.target.value)}
                  placeholder={`Option ${idx + 1}`}
                  className="form-control"
                />
                <button
                  type="button"
                  onClick={() => removeOption(idx)}
                  className="text-sm px-2 py-1 rounded bg-gray-100 hover:bg-gray-200"
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          <div className="mt-2">
            <button type="button" onClick={addOption} className="themeBlackBtn">
              + Add Option
            </button>
          </div>
        </div>

        <div className="flex items-center gap-3 mt-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
            />
            <span className="text-sm">Set as Active</span>
          </label>
          <span className="text-xs text-gray-500">
            (Active polls are visible to users)
          </span>
        </div>

        <div className="flex justify-end mt-4">
          <button type="submit" disabled={loading} className="themeBtn">
            {loading ? "Creating..." : "Create Poll"}
          </button>
        </div>
      </form>
    </div>
  );
}
